var TextTypes = require("lib/academic/TextTypes");

// Filters are directly applied as key value to query
// Conditions are applied in different ways depending on the key
export function filterBy(items, filters, conditions) {
	conditions = conditions || {};
	items = allRecords(items)
	if (!_.isEmpty(filters)) {
		items = _.where(items, filters);
	}

	if (!_.isEmpty(conditions)) {
		// All functions which take item and return if item should be included
		var conditionFilters = _.compact([
			buildInUserIDs(conditions),
			buildInTextIDs(conditions),
			buildInIDs(conditions),
			buildIsInTimeRange(conditions),
			buildInDueDateRange(conditions),
			buildIsTextVariety(conditions),
			buildInDraft(conditions)
		]);

		if (conditions.oneOfMatch) {
			_.each(conditions.oneOfMatch, (values, key) => {
				conditionFilters.push((item) => _.include(values, item[key]));
			})
		}

		if (conditions.nonBlank) {
			_.each(conditions.nonBlank, (key) => {
				conditionFilters.push((item) => (item[key] != null) && ((item[key] + "").trim().length > 0));
			})			
		}

		if (_.isEmpty(conditionFilters) && _.isEmpty(filters)) {
			return items;
		}

		items = _.select(items, (item) => {
			// All filters have to accept the item
			if (!_.all(conditionFilters, (filter) => filter(item))) {
				return false;
			}
			return true;
		});
	} 

	return items;
}

export function selectPage(reducerState, pageKey, page) {
	var pageDetails = reducerState.pages[pageKey];
	if (!pageDetails) { return []; }

	var pageIDs = pageDetails[page];
	if (!pageIDs) { return []; }

	return _.compact(_.map(pageIDs, (id) => reducerState[id]));
}

var IGNORE_VALUES = ["loading", "cached", "totals", "pages", "noMorePages"];
export function allRecords(reducerState) {
	return _.values(_.omit(reducerState, IGNORE_VALUES))
}

//////////////////////////////
// Private ///////////////////
//////////////////////////////

function buildIsInTimeRange(conditions) {
	if (conditions.startDate || conditions.endDate) {
		// Inclusive start, exclusive end
		var startTime = null, endTime = null;

		if (conditions.startDate) {
			startTime = $wr.momentInTimezone(conditions.startDate);
		}
		if (conditions.endDate) {
			endTime = $wr.momentInTimezone(conditions.endDate).add(1, "day");
		}

		return (item) => {
			var time, times;

			if (conditions.timeKey) {
				if (conditions.timeKey == "last_active_by_user_id") {
					var userIDs = extractUserIDs(conditions) || [];

					times = _.values(_.pick(item.last_actives || {}, userIDs));
				} else {
					time = item[conditions.timeKey];
				}

			} else {
				// The order here is important: keys coming earlier will be favored for checking
				// date inclusion if present on the object
				time = item.completed_at || item.created_at;
			}

			if (time) {
				return inTimeRange(startTime, endTime, $wr.momentInTimezone(time));

			} else if (times) {
				return _.any(times, (time) => inTimeRange(startTime, endTime, $wr.momentInTimezone(time)));

			} else {
				return false;
			}
		}
	}
}

function buildInDueDateRange(conditions) {
	var today = new Date();
	if (conditions.dueDate !== undefined) {
		if (conditions.dueDate === 'upcoming') {
			return (item) => {
				return new Date(item.due_date) > today
			}
		} else if (conditions.dueDate === 'past') {
			return (item) => {
				if (item.due_date !== null) {
					return new Date(item.due_date) < today
				}
			}
		} else if (conditions.dueDate === 'none') {
			return (item) => {
				return item.due_date === null
			}
		} else {
			return null
		}
	} else {
		return null
	}
}

// All should be moment objects
function inTimeRange(start, end, time) {
	return ((start == null) || (time >= start)) && 
				((end == null) || (time < end))
}

function extractUserIDs(conditions) {
	var manyIDs = conditions.studentIDs || conditions.adminIDs || conditions.userIDs;
	// Treat an empty array of userIDs the same as no constraint at all
	if ((manyIDs !== undefined) && (manyIDs.length > 0)) {
		return manyIDs;
	}

	var singleID = conditions.studentID || conditions.adminID || conditions.userID;
	if (singleID !== undefined) {
		return [singleID];
	}

	return undefined;
}

function buildInUserIDs(conditions) {
	var userIDs = extractUserIDs(conditions);

	if (!!userIDs) {
		userIDs = new Set(userIDs);
	}

	if (userIDs) {
		return (item) => {
			var userID = item.user_id || item.student_id || item.admin_id;
			if (userID !== undefined) {
				return userIDs.has(userID);
			}
			if (_.isArray(item.user_ids)) {
				return _.any(item.user_ids, (id) => userIDs.has(id));
			}
		}
	}
}

function buildInIDs(conditions) {
	if (conditions.ids) {
		var ids = new Set(conditions.ids);
		return (item) => {
			return ids.has(item.id);
		}
	}
}

function buildInTextIDs(conditions) {
	var textIDs;

	if ((conditions.textIDs !== undefined)) {
		textIDs = new Set(conditions.textIDs);
	}

	if (conditions.textID !== undefined) {
		textIDs = new Set([conditions.textID]);
	}

	if (textIDs) {
		return (item) => {
			if (item.text_id !== undefined) {
				return textIDs.has(item.text_id);
			}
			if (_.isArray(item.text_ids)) {
				return _.any(item.text_ids, (id) => textIDs.has(id));
			}
		}
	}
}

function buildIsTextVariety(conditions) {
	if (conditions.textVariety == TextTypes.Varieties.BOTH) {
		return null;
	} else if (conditions.textVariety) {
	    return (item) => {
	    	return item.text_variety == conditions.textVariety
	    };
	}
}

function buildInDraft(conditions) {
	if (conditions.draft === true || conditions.draft === false) {
		return (item) => {
			return item.draft == conditions.draft
		}
	} else {
		return null
	}
}
// returns valid tasks for student homepage
// includes:
// 	not completed, before due date
// 	not completed, less than 30 days past due date
//	not completed, no due date
//	completed, no due date, less than 7 days past completion date
// 	completed, not past due date
export function validStudentHomepageTasks(tasks) {
	// get 7 days ago
	var sevenDaysAgo = new Date();
	var pastDate = sevenDaysAgo.getDate() - 7;

	// get 30 days ago
	var thirtyDaysAgo = new Date();
	var pastDate = thirtyDaysAgo.getDate() - 30;
	thirtyDaysAgo.setDate(pastDate);

	var validTasks = _.map(tasks, (task) => {
		if (task.draft && task.due_date && new Date(task.due_date) > thirtyDaysAgo) {
			return task;
		} else if (task.draft && !task.due_date) {
			return task;
		} else if (!task.draft && !task.due_date && task.completed_at && new Date(task.completed_at) > new Date(sevenDaysAgo)) {
			return task;
		} else if (!task.draft && task.due_date && new Date(task.due_date) > new Date()) {
			return task;
		}
	})

	return _.compact(validTasks)
}


// WEBPACK FOOTER //
// ./modules/lib/shared/SelectorUtility.js